import { Tag, TagsMetadata } from '../../../state/types';

interface TagInfo {
  label: string;
  tooltip?: string;
  getAdditionalInfo?: (metadata: TagsMetadata) => string;
}

const map: Record<string, TagInfo> = {
  [Tag.APPEAL]: {
    label: 'Appeal(Commenter)',
    tooltip: 'Comment rejection appealed by a commenter'
  },
  [Tag.APPEAL_REPORTER]: {
    label: 'Appeal(Reporters)',
    tooltip: 'Report rejection/s appealed by reporter/s',
    getAdditionalInfo: (metadata: TagsMetadata) => {
      const { report_appeals } = metadata;
      if (!report_appeals) {
        return '';
      }
      const { count } = report_appeals;

      return count > 1 ? count.toString() : '';
    }
  },
  [Tag.REPORTED]: {
    label: 'Reported ',
    tooltip: 'Reported by a user',
    getAdditionalInfo: (metadata: TagsMetadata) => {
      const { report_reasons_V2 } = metadata;
      if (!report_reasons_V2) {
        return '';
      }
      const { total_count } = report_reasons_V2;

      return total_count > 1 ? total_count.toString() : '';
    }
  },
  [Tag.STAFF_REPORT]: {
    label: 'Staff Reported ',
    tooltip: 'Reported by a staff member',
    getAdditionalInfo: (metadata: TagsMetadata) => {
      const { super_report_reasons_V2 } = metadata;
      if (!super_report_reasons_V2) {
        return '';
      }
      const { total_count } = super_report_reasons_V2;

      return total_count > 1 ? total_count.toString() : '';
    }
  },
  [Tag.AI_MODERATED]: {
    label: 'Moderated by AI'
  }
};

export function getSelectableTagInfo(tab: Tag): TagInfo {
  return map[tab];
}
